import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

const tokenPrefix = (colorScheme: ColorScheme) =>
  colorScheme === 'light' ? 'light.' : ''

export const TOP_BAR_HEIGHT = '64px'

export const containerStyles = (
  colorScheme: ColorScheme
): SystemStyleObject => {
  const prefix = tokenPrefix(colorScheme)
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    // Fixed height so the bar is a consistent height across pages
    minHeight: TOP_BAR_HEIGHT,
    bg: `${prefix}bg.topbar`,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderColor: `${prefix}border.topbar`,
    px: '24px',
  }
}

export const breadcrumbStyles: SystemStyleObject = {
  display: 'flex',
  alignItems: 'center',
  gap: '30px',
  minWidth: 0,
}

export const breadcrumbItemStyles: SystemStyleObject = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  minWidth: 0,
}

export const labelStyles = (colorScheme: ColorScheme): SystemStyleObject => {
  const prefix = tokenPrefix(colorScheme)
  return {
    fontFamily: "'Soehne', sans-serif",
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '28px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: `${prefix}text.secondary`,
  }
}

export const separatorStyles = (
  colorScheme: ColorScheme
): SystemStyleObject => {
  const prefix = tokenPrefix(colorScheme)
  return {
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0,
    color: `${prefix}text.tertiary`,
  }
}

export const actionsStyles: SystemStyleObject = {
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  flexShrink: 0,
}

/** Theme token for loading skeleton fills (title / count), scheme-aware. */
export const skeletonBg = (colorScheme: ColorScheme): string =>
  `${tokenPrefix(colorScheme)}bg.skeleton`
